import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

import { EmailApiResponse } from "@core/models/api.response";

@Injectable({
  providedIn: "root",
})
export class EmailService {
  constructor(private http: HttpClient) {}

  validateEmail(email: string): Observable<EmailApiResponse> {
    return this.http.post<EmailApiResponse>(
      `${environment.apiUri}/profile/email/exists`,
      {
        email: email,
      }
    );
  }
}
